<script lang="ts">
	import { config, currentItem, filtersStore } from "../scripts/stores";
	import { Loader } from "../../generic/components";
	import { isNullish } from "../../generic/scripts/functions";
	import { msg } from "../scripts/getters";
	import { getControl } from "./controls";
	import InvalidParams from "./InvalidParams.svelte";

	export let invalidParams: [string, string][] = [];

	$: showParams = !isNullish($currentItem) && !isNullish($filtersStore) && $filtersStore.size > 0;
</script>

{#if showParams}
	<InvalidParams alertType="warning" title={msg("variant.notFound")} paramsTitle={msg("variant.invalidParams")} {invalidParams} />
	<div class="subitems-filters grid grid-cols-1 grid-lg-cols-2">
		{#each [...$filtersStore] as [_, filter] (filter.id)}
			{#if filter.values.size > 0}
				<svelte:component this={getControl(filter, $config)} {filter} on:change />
			{/if}
		{/each}
	</div>
{:else}
	<Loader outDelay={300} />
{/if}
